// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "rescript-classnames/src/Cn.bs.js";
import * as Util from "../../../common/util.bs.js";
import * as Category from "./Category.bs.js";
import * as Belt_Array from "@rescript/std/lib/es6/belt_Array.js";
import * as Caml_option from "@rescript/std/lib/es6/caml_option.js";
import * as CategoryMore from "./CategoryMore.bs.js";
import * as Belt_SetString from "@rescript/std/lib/es6/belt_SetString.js";
import * as CategoriesConf from "../../../config/CategoriesConf.bs.js";
import * as JsxRuntime from "react/jsx-runtime";

function CategoriesFilter(props) {
  var notEmptyCatigories = props.notEmptyCatigories;
  var selectCategory = props.selectCategory;
  var selectedCategory = props.selectedCategory;
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("h3", {
                      children: Util.ReactStuff.s("Browse by category"),
                      className: "text-15px ml-4"
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        Belt_Array.mapWithIndex(props.productTypeCategories, (function (i, category) {
                                var isVisibleAtSize = function (size) {
                                  return Belt_Array.keep(category.screens, (function (c) {
                                                return c === size;
                                              })).length === 1;
                                };
                                var match = category.slug;
                                var disabled = notEmptyCatigories !== undefined && match !== "all" ? !Belt_SetString.has(Caml_option.valFromOption(notEmptyCatigories), match) : false;
                                var classes = Cn.make([
                                      "w-1/4 mb-3 md:mb-0 lg:w-1/6 md:w-1/4",
                                      isVisibleAtSize("sm") ? "sm:block" : "sm:hidden",
                                      isVisibleAtSize("md") ? "md:block" : "",
                                      isVisibleAtSize("lg") ? "lg:block" : "",
                                      isVisibleAtSize("xl") ? "xl:block" : "",
                                      isVisibleAtSize("xxl") ? "xxl:block" : ""
                                    ]);
                                if (disabled) {
                                  return null;
                                } else {
                                  return JsxRuntime.jsx("div", {
                                              children: JsxRuntime.jsx(Category.make, {
                                                    category: category,
                                                    selectedCategory: selectedCategory,
                                                    selectCategory: selectCategory,
                                                    iconClassName: "select-none",
                                                    disabled: disabled
                                                  }),
                                              className: classes
                                            }, "category-bis-" + String(i));
                                }
                              })),
                        JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx(CategoryMore.make, {
                                    category: CategoriesConf.more,
                                    morePanelOpen: props.morePanelOpen,
                                    toggleMorePanel: props.toggleMorePanel,
                                    iconClassName: "w-5 h-5"
                                  }),
                              className: "hidden sm:block xxl:hidden w-1/4 mb-3 md:mb-0 lg:w-1/6 md:w-1/4 "
                            }, "category-none")
                      ],
                      className: "flex justify-start md:justify-between w-full flex-wrap md:flex-nowrap mt-2 lg:pb-3"
                    })
              ],
              className: props.className
            });
}

var make = CategoriesFilter;

export {
  make ,
}
/* Util Not a pure module */
